import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field  p-col-12" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field  p-col-12" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_8 = {
  key: 0,
  class: "p-field"
}
const _hoisted_9 = { class: "p-float-label p-mt-3 p-mx-2" }
const _hoisted_10 = {
  for: "persistTableName",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-mt-4" }, {
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "name",
              class: ["kn-material-input", { 'p-invalid': _ctx.v$.dataset.name.$invalid && _ctx.v$.dataset.name.$dirty }],
              type: "text",
              maxLength: "50",
              modelValue: _ctx.v$.dataset.name.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.name.$model = $event)),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.name.$touch())),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched'))),
              "data-test": "name-input"
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.dataset.name,
            additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_InputText, {
              id: "description",
              class: "kn-material-input",
              type: "text",
              maxLength: "50",
              modelValue: _ctx.dataset.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataset.description = $event)),
              "data-test": "description-input"
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.description')), 1)
          ])
        ]),
        _createVNode(_component_Toolbar, {
          class: "kn-toolbar kn-toolbar--secondary p-mt-1 p-mx-2",
          style: _ctx.dataViewDescriptor.style.maxwidth
        }, {
          start: _withCtx(() => [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.dataset.exportToHdfs,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataset.exportToHdfs = $event)),
              class: "p-mr-2",
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue"]),
            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.datasetManagement.isPersistedHDFS')), 1)
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode("div", {
          class: "persistence-container",
          style: _ctx.dataViewDescriptor.style.maxwidth
        }, [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-mt-3 p-mx-2" }, {
            start: _withCtx(() => [
              _createVNode(_component_InputSwitch, {
                modelValue: _ctx.dataset.persist,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataset.persist = $event)),
                disabled: _ctx.disablePersist,
                class: "p-mr-2",
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.datasetManagement.isPersisted')), 1)
            ]),
            _: 1
          }),
          (_ctx.dataset.persist)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, [
                  _createVNode(_component_InputText, {
                    id: "persistTableName",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.dataset.tableName.$invalid && _ctx.v$.dataset.tableName.$dirty
                                }],
                    type: "text",
                    maxLength: "50",
                    modelValue: _ctx.dataset.tableName,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dataset.tableName = $event)),
                    onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.dataset.tableName.$touch())),
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.datasetManagement.persistTableName')) + " *", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.dataset.tableName,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.persistTableName') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]))
            : _createCommentVNode("", true)
        ], 4)
      ])
    ]),
    _: 1
  }))
}